/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 08:53:31
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-13 16:06:09
 */
import axios from "axios"
import { Message, Notification } from "element-ui"
import errorCode from "../util/errorCode"
import { cityDetail } from "./mainOption"
import { mainReqUrl } from "./mainReqUrl"
import VueCookie from "vue-cookie"
import { signBySHA256WithRSAWB } from "./jsrsasign"
const service = axios.create({
  timeout: 15000
})
// request拦截器
service.interceptors.request.use(
  config => {
    // console.log('config.params', config.params)
    // console.log('config.data', config.data)
    // console.log(config.params)
    // localStorage.removeItem("deptId");
    // localStorage.removeItem("deptName");
    // let search = window.location.search;
    let deptId = config.headers.deptId ? config.headers.deptId : sessionStorage.getItem('deptId')
    config.headers["deptId"] = deptId // 让每个请求携带自定义token 请根据实际情况自行编辑
    config.url = "/prod-api" + config.url
    let cookieList = document.cookie.split("; ")
    if (cookieList.length != 0) {
      cookieList = cookieList.map(item => item.split("=")[0])
      for (let cookie of cookieList) {
        if (VueCookie.get(cookie) && ((VueCookie.get(cookie).toString()) == "undefined")) {
          VueCookie.delete(cookie)
        }
      }
    }
    if (config.url.indexOf("/api/") >= 0) {
      let timeStamp = new Date().getTime()
      let sign = signBySHA256WithRSAWB(deptId, timeStamp)
      config.headers.sign = sign
      config.headers.timeStamp = timeStamp
    }
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  res => {
    // _this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
    // });
    // loading.close();

    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"]

    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res.data
    }
    if (code === 401 && (localStorage.getItem("token") || localStorage.getItem("phone"))) {
      //   MessageBox.confirm(
      //     "登录状态已过期，您可以继续留在该页面，或者重新登录",
      //     "系统提示",
      //     {
      //       confirmButtonText: "重新登录",
      //       cancelButtonText: "取消",
      //       type: "warning"
      //     }
      //   )
      //     .then(() => {

      //     })
      //     .catch(() => {
      //     });
      Message({
        message: "会话已过期，请重新登录。",
        type: "error"
      })
      localStorage.removeItem('token')
      localStorage.removeItem('phone')
      if (cityDetail.homeShowLogin) {
        this.$router.push('/')
      } else {
        this.$router.push('/login')
      }

      return Promise.reject("无效的会话，或者会话已过期，请重新登录。")
    } else if (code === 401 || code === 302) {
      // Message({
      //   message: "当前未登录",
      //   type: "error"
      // })
      return res
    } else if (code === 500) {
      Message({ message: msg, type: "error" })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      Message({ message: msg, type: "warning" })
      return Promise.reject("error")
    } else if (code !== 200) {
      Notification.error({ title: msg })
      return Promise.reject("error")
    } else {
      // 响应对象序列化后替换图片地址为代理地址
      if (mainReqUrl.imageBaseUrl || mainReqUrl.imageBaseUrl1 || mainReqUrl.imageBaseUrl2 || mainReqUrl.imageBaseUrl3) {
        let strResData = JSON.stringify(res.data)
        while (strResData.indexOf(mainReqUrl.imageBaseUrl) != -1) {
          strResData = strResData.replace(
            mainReqUrl.imageBaseUrl,
            "/image-api"
          )
        }
        while (strResData.indexOf(mainReqUrl.imageBaseUrl1) != -1) {
          strResData = strResData.replace(
            mainReqUrl.imageBaseUrl1,
            "/image1-api"
          )
        }
        while (strResData.indexOf(mainReqUrl.imageBaseUrl2) != -1) {
          strResData = strResData.replace(
            mainReqUrl.imageBaseUrl2,
            "/image2-api"
          )
        }
        while (strResData.indexOf(mainReqUrl.imageBaseUrl3) != -1) {
          strResData = strResData.replace(
            mainReqUrl.imageBaseUrl3,
            "/image3-api"
          )
        }
        res.data = JSON.parse(strResData)
      }
      return res
    }
  },
  error => {
    // loading.close();
    // console.log('err' + error)
    let { message } = error
    if (message == "Network Error") {
      message = "后端接口连接异常"
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时"
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常"
    }
    Message({ message: message, type: "error", duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

export default service
